import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PriceDisplayMulticrypto from './PriceDisplayMulticrypto';

class PriceBSMulticrypto extends PureComponent {

  render(){
    return(
      <div className='price-disp-cont'>
        <PriceDisplayMulticrypto
            price={this.props.rate.multicrypto_rates[this.props.coin.name.toLowerCase()] ? this.props.rate.multicrypto_rates[this.props.coin.name.toLowerCase()].price : null}
            className={this.props.className}
            coin_ticker={this.props.coin.ticker}
        />
      </div>
    )
  }
}

function mapStateToProps(state){
  return{
    rate: state.rate
  } 
}

export default connect(mapStateToProps)(PriceBSMulticrypto);